import type { Action, GameState } from '@ic/engine';

let worker: Worker | null = null;
let nextId = 0;
const pending = new Map<number, (a: Action | null) => void>();

function get(): Worker {
  if (!worker) {
    worker = new Worker(new URL('../workers/bot.worker.ts', import.meta.url), { type: 'module' });
    worker.onmessage = (e: MessageEvent<{ id: number; action: Action | null }>) => {
      pending.get(e.data.id)?.(e.data.action);
      pending.delete(e.data.id);
    };
  }
  return worker;
}

/** Strongest move the engine finds for the side to move (admin helper). Works for every ruleset. */
export function bestMove(state: GameState, level = 8): Promise<Action | null> {
  const id = ++nextId;
  return new Promise((resolve) => {
    pending.set(id, resolve);
    get().postMessage({ id, state, level });
  });
}
